






import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RoomMembersChip extends Vue {
  @Prop({ required: true }) private members!: number;
}
